<template> 
    <div>
        <div class="drawer-content">
                <ul class='drawer-ul'>
                    <li class="drawer-li-left">
                        <p>主题方案</p>
                    </li>
                    <br> <br> 
                        <el-radio-group v-model="skinConfig.theme_type" @change="changeThemeType">
                            <el-radio-button label="1">经典蓝</el-radio-button>
                            <el-radio-button label="2">清纯蓝</el-radio-button>
                            <el-radio-button label="3">护眼绿</el-radio-button>  
                            <el-radio-button label="4">活力橙</el-radio-button>  
                            <el-radio-button label="5">少女粉</el-radio-button>
                            <el-radio-button label="9">自定义</el-radio-button>
                        </el-radio-group>  
                     <br> 
                
                </ul><br> <br> 
                <ul class='drawer-ul'>
                    <li class="drawer-li-left">
                        <p>主题背景色</p>
                    </li>
                    <li class="drawer-li-right">
                        <el-color-picker :disabled="themeLock"
                            v-model="skinConfig.theme_bgcolor"
                            @change="changeTheme"
                            show-alpha
                            :predefine="predefineColors">
                        </el-color-picker>
                    </li>
                </ul>
                <ul class='drawer-ul'>
                    <li class="drawer-li-left">
                        <p>主题文字颜色</p>
                    </li>
                    <li class="drawer-li-right">
                        <el-color-picker :disabled="themeLock"
                            v-model="skinConfig.theme_color"
                            @change="changeTheme"
                            show-alpha
                            :predefine="predefineColors">
                        </el-color-picker>
                    </li>
                </ul>
                <ul class='drawer-ul'>
                    <li class="drawer-li-left">
                        <p>侧边栏背景色</p>
                    </li>
                    <li class="drawer-li-right">
                        <el-color-picker :disabled="themeLock"
                            v-model="skinConfig.left_bgcolor"
                            @change="changeTheme"
                            show-alpha
                            :predefine="predefineColors">
                        </el-color-picker>
                    </li>
                </ul>
                <ul class='drawer-ul'>
                    <li class="drawer-li-left">
                        <p>侧边栏文字颜色</p>
                    </li>
                    <li class="drawer-li-right">
                        <el-color-picker :disabled="themeLock"
                            v-model="skinConfig.left_color"
                            @change="changeTheme"
                            show-alpha
                            :predefine="predefineColors">
                        </el-color-picker>
                    </li>
                </ul>
                <ul class='drawer-ul'>
                    <li class="drawer-li-left">
                        <p>滑过背景色</p>
                    </li>
                    <li class="drawer-li-right">
                        <el-color-picker :disabled="themeLock"
                            v-model="skinConfig.hover_bgcolor"
                            @change="changeTheme"
                            show-alpha
                            :predefine="predefineColors">
                        </el-color-picker>
                    </li>
                </ul>
                <ul class='drawer-ul'>
                    <li class="drawer-li-left">
                        <p>滑过文字颜色</p>
                    </li>
                    <li class="drawer-li-right">
                        <el-color-picker :disabled="themeLock"
                            v-model="skinConfig.hover_color"
                            @change="changeTheme"
                            show-alpha
                            :predefine="predefineColors">
                        </el-color-picker>
                    </li>
                </ul>
                <ul class='drawer-ul'>
                    <li class="drawer-li-left">
                        <p>顶部背景色</p>
                    </li>
                    <li class="drawer-li-right">
                        <el-color-picker :disabled="themeLock"
                            v-model="skinConfig.top_bgcolor"
                            @change="changeTheme"
                            show-alpha
                            :predefine="predefineColors">
                        </el-color-picker>
                    </li>
                </ul>
                <ul class='drawer-ul'>
                    <li class="drawer-li-left">
                        <p>顶部文字颜色</p>
                    </li>
                    <li class="drawer-li-right">
                        <el-color-picker :disabled="themeLock"
                            v-model="skinConfig.top_color"
                            @change="changeTheme"
                            show-alpha
                            :predefine="predefineColors">
                        </el-color-picker>
                    </li>
                </ul>
            </div>
                     
    </div>
</template>

<script>
    import bus from './bus';
    export default {
        data() {
            return {
                themeLock:true,
                color: 'rgba(255, 69, 0, 0.68)', 
                predefineColors: [
                    '#ff4500',
                    '#ff8c00',
                    '#ffd700',
                    '#90ee90',
                    '#00ced1',
                    '#1e90ff',
                    '#c71585',
                    'rgba(255, 69, 0, 0.68)',
                    'rgb(255, 120, 0)',
                    'hsv(51, 100, 98)',
                    'hsva(120, 40, 94, 0.5)',
                    'hsl(181, 100%, 37%)',
                    'hsla(209, 100%, 56%, 0.73)',
                    '#c7158577'
                ],
                skinConfig:{
                    theme_type:'',
                    theme_bgcolor:'',
                    theme_color:'',
                    hover_bgcolor:'',
                    hover_color:'',
                    left_bgcolor:'',
                    left_color:'',
                    top_bgcolor:'',
                    top_color:'',
                },
                skinConfig1 :  {
                    hover_bgcolor: "rgba(3, 115, 224, 1)",
                    hover_color: "rgba(225, 225, 225, 1)",
                    left_bgcolor: "rgba(20, 20, 20, 1)",
                    left_color: "rgba(225, 225, 225, 1)",
                    theme_bgcolor: "rgba(3, 115, 224, 1)",
                    theme_color: "rgba(255, 255, 255, 1)",
                    theme_type: "1",
                    top_bgcolor: "rgba(255, 255, 255, 1)",
                    top_color: "rgba(52, 52, 52, 1)",
                },
                skinConfig2 :  {
                    hover_bgcolor: "rgba(238, 238, 238, 1)",
                    hover_color: "rgba(3, 115, 224, 1)",
                    left_bgcolor: "rgba(255, 255, 255, 1)",
                    left_color: "rgba(52, 52, 52, 1)",
                    theme_bgcolor: "rgba(3, 115, 224, 1)",
                    theme_color: "rgba(255, 255, 255, 1)",
                    theme_type: "2",
                    top_bgcolor: "rgba(255, 255, 255, 1)",
                    top_color: "rgba(52, 52, 52, 1)",
                },
                skinConfig3 :  {
                    hover_bgcolor: "rgba(144, 238, 144, 1)",
                    hover_color: "rgba(0, 0, 0, 1)",
                    left_bgcolor: "rgba(221, 251, 221, 0.66)",
                    left_color: "rgba(47, 47, 47, 1)",
                    theme_bgcolor: "rgba(0, 194, 0, 0.9)",
                    theme_color: "rgba(255, 255, 255, 1)",
                    theme_type: "3",
                    top_bgcolor: "rgba(255, 255, 255, 1)",
                    top_color: "rgba(52, 52, 52, 1)",
                },
                skinConfig4 :  {
                    hover_bgcolor: "rgba(238, 238, 238, 1)",
                    hover_color: "rgba(255, 120, 0, 1)",
                    left_bgcolor: "rgba(255, 255, 255, 1)",
                    left_color: "rgba(52, 52, 52, 1)",
                    theme_bgcolor: "rgba(255, 120, 0, 1)",
                    theme_color: "rgba(255, 255, 255, 1)",
                    theme_type: "4",
                    top_bgcolor: "rgba(255, 255, 255, 1)",
                    top_color: "rgba(52, 52, 52, 1)",
                },
                skinConfig5 :  {
                    hover_bgcolor: "rgba(248,72,139,0.8)",
                    hover_color: "rgb(255,255,255,1)",
                    left_bgcolor: "rgba(255, 255, 255, 1)",
                    left_color: "rgba(52, 52, 52, 1)",
                    theme_bgcolor: "rgb(248,72,139,1)",
                    theme_color: "rgba(255, 255, 255, 1)",
                    theme_type: "5",
                    top_bgcolor: "rgba(255, 255, 255, 1)",
                    top_color: "rgba(52, 52, 52, 1)",
                },
                
            }
        },
        methods: {
            changeTheme(){ 
                
                var skinData = this.skinConfig; 
                document.documentElement.style.setProperty('--theme_type', skinData.theme_type);
                document.documentElement.style.setProperty('--theme_bgcolor', skinData.theme_bgcolor);
                document.documentElement.style.setProperty('--theme_color', skinData.theme_color);
                document.documentElement.style.setProperty('--hover_bgcolor', skinData.hover_bgcolor);
                document.documentElement.style.setProperty('--hover_color', skinData.hover_color);
                document.documentElement.style.setProperty('--left_bgcolor', skinData.left_bgcolor);
                document.documentElement.style.setProperty('--left_color', skinData.left_color);
                document.documentElement.style.setProperty('--top_bgcolor', skinData.top_bgcolor);
                document.documentElement.style.setProperty('--top_color', skinData.top_color);
                localStorage.setItem(window.location.hostname+'_cl_skinConfig',JSON.stringify(skinData)); 
            },
            changeThemeType(){  
                if(this.skinConfig.theme_type==9){
                    this.themeLock = false;
                }else{
                    if(this.skinConfig.theme_type==1){
                        this.skinConfig =  this.skinConfig1;
                    }else if(this.skinConfig.theme_type==2){
                        this.skinConfig =  this.skinConfig2;
                    }else if(this.skinConfig.theme_type==3){
                        this.skinConfig =  this.skinConfig3;
                    } else if(this.skinConfig.theme_type==4){
                        this.skinConfig =  this.skinConfig4;
                    } else if(this.skinConfig.theme_type==5){
                        this.skinConfig =  this.skinConfig5;
                    }
                    localStorage.setItem(window.location.hostname+'_cl_skinConfig',JSON.stringify(this.skinConfig)); 
                    this.initTheme();
                    this.initWord();
                    this.themeLock = true;
                }
                
            },
            initTheme(){
                let skinConfig = localStorage.getItem(window.location.hostname+'_cl_skinConfig');
                if(skinConfig==null || skinConfig==undefined){
                    localStorage.removeItem(window.location.hostname+'_cl_skinConfig')
                    localStorage.setItem(window.location.hostname+'_cl_skinConfig',JSON.stringify(this.skinConfig));
                }
                this.skinConfig = JSON.parse(skinConfig);
                var skinData = JSON.parse(skinConfig); 
                document.documentElement.style.setProperty('--theme_type', skinData.theme_type);
                document.documentElement.style.setProperty('--theme_bgcolor', skinData.theme_bgcolor);
                document.documentElement.style.setProperty('--theme_color', skinData.theme_color);
                document.documentElement.style.setProperty('--hover_bgcolor', skinData.hover_bgcolor);
                document.documentElement.style.setProperty('--hover_color', skinData.hover_color);
                document.documentElement.style.setProperty('--left_bgcolor', skinData.left_bgcolor);
                document.documentElement.style.setProperty('--left_color', skinData.left_color);
                document.documentElement.style.setProperty('--top_bgcolor', skinData.top_bgcolor);
                document.documentElement.style.setProperty('--top_color', skinData.top_color);
            }
        },
        computed: {
             
        },
        watch:{
             
        },
        created(){
           this.initTheme();
        }
    }

</script>


<style>
 .el-button--text span{
        padding:0 15px !important;
    }
    .drawer-content{
        width:90%;
        padding:0 5%;
    }
    .drawer-ul{
        width: 100%;
        height: 50px;
    }
    .drawer-ul li{
        list-style:none;
    }
    .drawer-li-left{
        float:left;
    }
    .drawer-li-right{
        float:right;
    }
</style>
